import type { SectionIcon } from './types'

export const keyfeaturesIcons: SectionIcon[] = [
  {
    identifier: 'air_conditioning',
    icon: 'airConditioning',
  },
  {
    identifier: 'pool',
    icon: 'swimmingPool',
  },
  {
    identifier: 'pool',
    icon: 'swimmingPool',
  },
  {
    identifier: 'private_beach',
    icon: 'privateBeachAccess',
  },
  {
    identifier: 'beach_feet_in_the_water',
    icon: 'beachWithinWalkingDistance',
  },
  {
    identifier: 'beach_on_foot',
    icon: 'nearBeach',
  },
  {
    identifier: 'ski_trail_ski_in_ski_out',
    icon: 'skiInOut',
  },
  {
    identifier: 'ski_trail_on_foot',
    icon: 'skiWithinWalkingDistance',
  },
  {
    identifier: 'tennis_court',
    icon: 'tennis',
  },
  {
    identifier: 'padel_court',
    icon: 'padel',
  },
  {
    identifier: 'elevator',
    icon: 'lift',
  },
  {
    identifier: 'jacuzzi',
    icon: 'outdoorJacuzzi',
  },
  {
    identifier: 'hammam',
    icon: 'hammam',
  },
  {
    identifier: 'sauna',
    icon: 'sauna',
  },
  {
    identifier: 'nordic_bath',
    icon: 'nordicBath',
  },
  {
    identifier: 'petanque',
    icon: 'petanque',
  },
  {
    identifier: 'football_field',
    icon: 'football',
  },
  {
    identifier: 'badminton_court',
    icon: 'badminton',
  },
  {
    identifier: 'volleyball_court',
    icon: 'volley',
  },
  {
    identifier: 'basketball_court',
    icon: 'basketball',
  },
  {
    identifier: 'fitness_room',
    icon: 'trainingBike',
  },
  {
    identifier: 'movie_room',
    icon: 'popcorn',
  },
  {
    identifier: 'massage_room',
    icon: 'massage',
  },
  {
    identifier: 'conference_room',
    icon: 'conference',
  },
  {
    identifier: 'barbecue',
    icon: 'barbecue',
  },
  {
    identifier: 'grill',
    icon: 'plancha',
  },
  {
    identifier: 'fireplace',
    icon: 'fireplace',
  },

  {
    identifier: 'chef',
    icon: 'chef',
  },
  {
    identifier: 'butler',
    icon: 'butler',
  },
  {
    identifier: 'staff_at_home',
    icon: 'homeStaff',
  },
  {
    identifier: 'car_with_driver',
    icon: 'driver',
  },
  {
    identifier: 'breakfast_preparation',
    icon: 'teapot',
  },
  {
    identifier: 'guardian',
    icon: 'securityGuard',
  },
  {
    identifier: 'security_guard',
    icon: 'securityGuard',
  },
  {
    identifier: 'villa_manager',
    icon: 'villaChaletManager',
  },
  {
    identifier: 'chalet_manager',
    icon: 'villaChaletManager',
  },
  {
    identifier: 'home_fitting_of_ski_equipment',
    icon: 'homeSkiFitting',
  },
  {
    identifier: 'transfer',
    icon: 'car',
  },
  {
    identifier: 'free_access_to_a_golf_course',
    icon: 'freeGolfAccess',
  },
  {
    identifier: 'golf',
    icon: 'golfNearby',
  },
  {
    identifier: 'free_access_to_a_shared_tennis_court',
    icon: 'tennisAccess',
  },
  {
    identifier: 'garden',
    icon: 'garden',
  },
  {
    identifier: 'pool_house',
    icon: 'poolHouse',
  },
  {
    identifier: 'game_room',
    icon: 'children',
  },
  {
    identifier: 'billiard_room',
    icon: 'pool',
  },
  {
    identifier: 'nature_reserve',
    icon: 'naturalReserve',
  },
  {
    identifier: 'private_domain',
    icon: 'privateDomain',
  },
  {
    identifier: 'vineyard',
    icon: 'vineyard',
  },
  {
    identifier: 'surrounded_by_fields',
    icon: 'surroundedByFields',
  },
  {
    identifier: 'floor_heating_system',
    icon: 'floorHeating',
  },
  {
    identifier: 'cooling_floor_system',
    icon: 'coolingFloor',
  },
  {
    identifier: 'jacuzzi_bathtub',
    icon: 'jacuzziBathtub',
  },
  {
    identifier: 'hammam_shower',
    icon: 'hammamShower',
  },
  {
    identifier: 'ski_room',
    icon: 'ski',
  },
  {
    identifier: 'boot_warmer',
    icon: 'shoeWarmer',
  },
]
